import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import useZustandStore from "@src/helpers/zustand";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { WITH_PAYUNICARD } from "@src/utils/consts";

interface DataType {
  apiKey?: string;
  phone?: string;
}

const apiCall = async ({ apiKey, ...data }: DataType) => {
  const response = await axiosInstance.post<unknown>("/api/otp/phone", data, {
    headers: {
      "x-api-key": apiKey,
    },
  });
  return response.data;
};

export const useSendOtp = (successCallback?: () => void) => {
  const navigate = useNavigate();
  const { data: zData, setData } = useZustandStore((state) => state);
  const location = useLocation();

  const { i18n } = useTranslation();
  return useMutation(apiCall, {
    onSuccess() {
      if (successCallback) {
        successCallback();
      }

      const isRedirectedFromPay = location.search.includes(
        "redirected_from=identify-with-payunicard"
      );

      if (WITH_PAYUNICARD && isRedirectedFromPay) {
        navigate(
          `/${i18n.language}/otp?redirected_from=identify-with-payunicard`
        );
      } else {
        navigate(`/${i18n.language}/otp`);
      }
    },
    onError({ response }) {
      setData({
        ...zData,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- we trust the api
        errorMessage: response.data.displayText || response.data.DisplayText,
      });
      navigate(`/${i18n.language}/error`);
    },
  });
};
